import mongoose from "mongoose";

export enum Action {
    SignIn = "sign in",
    SignUp = "sign up",
    FavoriteRemoved = "favorite removed", // value of object favorite removed
    FavoriteAdded = "favorite add", // value of object favorite added
    UserInfoUpdate = "user info update", // objects of field changed and new value
    FileUpload = "file upload",
    SignInIncorrectPassword = "incorrect password",
    SignInUserNotFound = "user not found",
}

export interface UserActivityLog {
    userId: mongoose.Types.ObjectId;
    action: Action;
}

export interface FavoriteAddedActivityLog extends UserActivityLog {
    value: string;
}

export interface FavoriteRemovedActivityLog extends UserActivityLog {
    value: string;
}

export interface UserInfoUpdateActivity extends UserActivityLog {
    changes: Array<{ path: string; value: any }>;
}
